<template>
    <div class="tw-form-item">
        <label class="tw-form-item__label" :style="`width: ${label_width}`">
            <span style="color: red;" v-if="!allow_null">*</span>
            {{label}}
        </label>
        <div class="tw-form-item__content" :style="`width: ${edit_width}`">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'tw-form-item',
    props: {
        label: {
            type: String,
            default: "标题"
        },
        label_width: {
            type: String,
            default: "80px"
        },
        edit_width: {
            type: String,
            default: "100%"
        },
        allow_null: {
            type: Boolean,
            default: true
        }
    }
}
</script>